export default {
    mounted: function () {
        this.counterLoaded = false;
        if (this.counterId != 0) {
            this.$ajax.get(`/rest/documents/counters/${this.counterId}`, {}, (data) => {
                this.counter = data;
                this.originalGlue = this.counter.glue;

                this.counterLoaded = true;
            });
        }
    },
    data() {
        return {
            errors: {},
            counter: {},
            counterWidth: [1, 2, 3, 4, 5, 6, 7],
            originalGlue: '',

            counterLoaded: false,
        };
    },
    computed: {
        preview: function () {
            const cut = this.counter.glue == 'none' ? 0 : 1;
            const date = this.dateFormat == '' ? '' : moment().format(this.dateFormat);
            const glue = this.glues.find((g) => {
                return g.value == this.counter.glue;
            }).glue;

            let preview = this.counter.style;
            if (date == '') {
                preview = this.counter.style.replace(/date/g, '');
            } else {
                preview = this.counter.style.replace(/date/g, glue + date);
            }
            return preview
                .replace(/num/g, glue + this.counter.identcounter)
                .replace(/root/g, glue + this.counter.root)
                .substring(cut);
        },

        dateFormat: function () {
            const formats = {
                Ymd: 'YYYYMMDD',
                dmY: 'DDMMYYYY',
                mdY: 'MMDDYYYY',
                Ym: 'YYYYMM',
                yym: 'YYMM',
                yy: 'YY',
                Y: 'YYYY',
                yymd: 'YYMMDD',
                '': '',
            };

            return formats[this.counter.dateformat];
        },

        /**
         * Build a glue list with only compliant glue. Add old glue for old counter
         */
        builtGlues: function () {
            return this.glues.filter((glue) => {
                return glue.compliance || (!glue.compliance && glue.value == this.originalGlue);
            });
        },

        title: function () {
            switch (this.counter.doctype) {
                case 'invoice':
                    if (this.counter.step == 'draft') {
                        return this.$l10n.__(
                            'Modification de la numérotation des factures brouillon',
                        );
                    }
                    return this.$l10n.__('Modification de la numérotation des factures');
                    break;
                case 'estimate':
                    return this.$l10n.__('Modification de la numérotation des devis');
                    break;
                case 'order':
                    return this.$l10n.__('Modification de la numérotation des bons de commande');
                    break;
                case 'delivery':
                    return this.$l10n.__('Modification de la numérotation des bons de livraison');
                    break;
                case 'creditnote':
                    if (this.counter.step == 'draft') {
                        return this.$l10n.__(
                            'Modification de la numérotation des avoirs brouillon',
                        );
                    }
                    return this.$l10n.__('Modification de la numérotation des avoirs');
                    break;
                case 'proforma':
                    return this.$l10n.__('Modification de la numérotation des factures proforma');
                    break;
                default:
                    return this.$l10n.__('Modification de la numérotation des documents');
                    break;
            }
        },
        subtitle: function () {
            switch (this.counter.doctype) {
                case 'invoice':
                    if (this.counter.step == 'draft') {
                        return this.$l10n.__(
                            'Personnalisez votre compteur numérotation de facture brouillon. Vous pouvez définir ici le prochain numéro de facture brouillon, obligatoirement sur 5 chiffres.',
                        );
                    }
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de facture',
                    );
                    break;
                case 'estimate':
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de devis',
                    );
                    break;
                case 'order':
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de bon de commande',
                    );
                    break;
                case 'delivery':
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de bon de livraison',
                    );
                    break;
                case 'creditnote':
                    if (this.counter.step == 'draft') {
                        return this.$l10n.__(
                            "Personnalisez votre compteur numérotation d'avoir brouillon. Vous pouvez définir ici le prochain numéro d'avoir brouillon, obligatoirement sur 5 chiffres.",
                        );
                    }
                    return this.$l10n.__(
                        "Personnalisez comme vous le souhaitez votre numérotation d'avoir",
                    );
                    break;
                case 'proforma':
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de facture proforma',
                    );
                    break;
                default:
                    return this.$l10n.__(
                        'Personnalisez comme vous le souhaitez votre numérotation de document',
                    );
                    break;
            }
        },
    },
    methods: {
        save: function () {
            const options = {
                root: this.counter.root.trim(),
                dateFormat: this.counter.dateformat,
                glue: this.counter.glue,
                style: this.counter.style,
                counter: Math.abs(parseInt(this.counter.identcounter) - 1),
                zeroFill: this.counter.identcounterzerofill,
            };

            this.$ajax.put(
                `/rest/documents/counters/${this.counterId}`,
                {},
                options,
                (data) => {
                    this.$emit('close-popup', data);
                },
                (error) => {
                    const errors = {};
                    const errorMessage = [];
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        errors[key.substring(1, key.length - 1)] = messages[key];
                    });
                    Object.keys(messages).forEach(function (key) {
                        errorMessage.push(`${messages[key]}`);
                    });
                    Push.error(errorMessage.join(', '));
                    this.errors = errors;
                },
            );
        },
        updateLengthCounter: function (newLength) {
            const zero = '0000000';
            const actualLength = this.counter.identcounter.length;

            if (actualLength > newLength) {
                this.counter.identcounter = this.counter.identcounter.substring(
                    actualLength - newLength,
                );
            } else {
                this.counter.identcounter =
                    zero.substring(0, newLength - actualLength) + this.counter.identcounter;
            }
        },
        handleClose: function (done) {
            this.$emit('close-popup');
        },
    },
};
